import _ from 'lodash';

export const selectCollapseSideBar = state => _.get(state, ['collapseSideBar'], false);
